import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { selectOccupation } from '../../redux/selectors'

export const OccupationName = ({ occupation }) => (
	occupation
	?	<span>{ occupation.name }</span>
	:	null
)

const mapStateToProps = (state, ownProps) => ({
	occupation: selectOccupation(ownProps.occupationId)(state)
})

export default connect(mapStateToProps)(OccupationName)